"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alphabet = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
];
/** @deprecated */
function getLetterByIndex(index) {
    var letter = alphabet[index];
    if (index >= alphabet.length || index < 0 || !letter) {
        return 'X';
    }
    return letter;
}
exports.default = getLetterByIndex;
//# sourceMappingURL=getLetterByIndex.js.map